import { Component, inject, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { HttpMethod } from '@lib/util';
import { IOciCatalogConfig } from '../types/IOciCatalogConfig';

/**
 * This component serves as a redirection component for OCI punchout. The user gets redirected to the OCI punchout URL
 * with the provided HTTP method.
 * <br>
 * This component expects the query params to follow the interface IOciCatalogConfig.
 */
@Component({
    selector: 'oci-redirection',
    imports: [],
    template: ''
})
export class OciRedirectionComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);

    ngOnInit(): void {
        const config = this.route.snapshot.queryParams as IOciCatalogConfig;
        if (config.staticShopUrl) {
            this.redirectToStaticUrl(config.staticShopUrl, config.httpMethod);
        } else {
            this.redirectNonStatic(config);
        }
    }

    private redirectToStaticUrl(catalogUrl: string, method: string): void {
        if (method.toUpperCase() === HttpMethod.POST) {
            this.openStaticCatalogWithPostMethod(catalogUrl);
        } else {
            this.openStaticCatalogWithGetMethod(catalogUrl);
        }
    }

    private openStaticCatalogWithPostMethod(url: string): void {
        const ociForm = document.createElement('form');
        ociForm.target = '_self';
        ociForm.method = HttpMethod.POST;
        ociForm.action = url;

        document.body.appendChild(ociForm);

        ociForm.submit();
        document.body.removeChild(ociForm);
    }

    private openStaticCatalogWithGetMethod(url: string): void {
        window.location.href = url;
    }

    private redirectNonStatic(config: IOciCatalogConfig): void {
        const form = document.createElement('form');
        form.method = config.httpMethod;
        form.action = config.shopUrl;
        form.target = '_self';

        this.addInputToForm('OCI_VERSION', config.ociVersion, form);
        this.addInputToForm('PASSWORD', config.password, form);
        this.addInputToForm('USERNAME', config.user, form);
        this.addInputToForm('~CALLER', config.caller, form);
        this.addInputToForm('~OkCode', config.okCode, form);
        this.addInputToForm('HOOK_URL', config.hookUrl, form);
        this.addInputToForm('returntarget', '_parent', form);

        document.body.appendChild(form);

        form.submit();
        document.body.removeChild(form);
    }

    private addInputToForm(name: string, value: string, form: HTMLFormElement): void {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }
}
